import { axiosDS } from '@pp/axios'
import { CompanyModel } from 'Pages/company'
import { urls } from 'Constants/Urls'

export const partnerAddressesApi = {
	getPartnerAddresses: async (id: number) => {
		const res = await axiosDS().get<CompanyModel[]>(`${urls.company.address}/${id}/addresses`)
		return res.data
	},
	createPartnerAddresses: async (partnerId: number, data: CompanyModel) => {
		const res = await axiosDS().post(`${urls.company.address}/${partnerId}/addresses`, {
			data,
		})
		return res.data
	},
	updatePartnerAddresses: async (partnerId: number, addressId: number, data: CompanyModel) => {
		const res = await axiosDS().patch(
			`${urls.company.address}/${partnerId}/addresses/${addressId}`,
			{
				data,
			}
		)
		return res.data
	},
	deletePartnerAddresses: async (partnerId: number, addressId: number) => {
		const res = await axiosDS().delete(
			`${urls.company.address}/${partnerId}/addresses/${addressId}`
		)
		return res.data
	},
}
